<template>
    <v-dialog
        v-model="abrir"
        max-width="450px" 
        scrollable
        persistent>
        
        <v-card>
            <v-card-title>
                <span class="headline">{{ titulo }}</span>
            </v-card-title>

            <v-card-text>
                <v-container grid-list-md xs12 sm12 md12>
                    <v-layout>
                        <v-tabs
                            color="indigo darken-4"
                            dark
                            fixed-tabs
                            slider-color="yellow"
                            icons-and-text >

                            <v-tab class="mr-3">
                                <v-icon class="mr-2">mdi-pencil-outline</v-icon>
                                Datos generales
                            </v-tab>
                            <v-tab class="mr-3">
                                <v-icon class="mr-2">mdi-cow</v-icon>
                                Seleccion de animales
                            </v-tab>
                            <v-tab-item>
                                <v-flex xs12 sm12 md12>
                                    <v-select
                                        class = "body-1"
                                        :items = "cbTipoServicio"
                                        v-model = "datos['tiposervicio']"
                                        label = "Tipo de Servicio"
                                        @change = "actualizarFormulario"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <v-select
                                        class = "body-1"
                                        :items = "cbMedicos"
                                        v-model = "datos['encargado']"
                                        label = "Médico encargado"
                                    ></v-select>
                                </v-flex>
                                <v-flex>
                                    <v-menu
                                        ref="menuFechaIni"
                                        :close-on-content-click="false"
                                        v-model="menuFechaIni"
                                        :nudge-right="40"
                                        :return-value.sync="date"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                    >
                                        <v-text-field
                                        slot="activator"
                                        v-model = "datos['fechainicio']"
                                        label="Fecha tentativa de inicio"
                                        prepend-icon="mdi-calendar-month"
                                        readonly>
                                        </v-text-field>
                                        <v-date-picker header-color = "blue darken-3" dark v-model = "datos['fechainicio']" @input="$refs.menuFechaIni.save(datos['fechainicio'])"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <v-select
                                        class = "body-1"
                                        :items = "cbRanchos"
                                        v-model = "datos['rancho']"
                                        label = "Rancho"
                                        @change = "actualizarTabla"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <v-select
                                        v-show = "datAdicional === true && semen === true"
                                        class = "body-1"
                                        :items = "cbSemen"
                                        v-model = "datos['semen']"
                                        label = "Tipo de semen a utilizar"
                                    ></v-select>
                                    <v-text-field
                                        v-show = "datAdicional === true && semen === false"
                                        v-model = "datos['idtoro']"
                                        label = "Identificador del Toro"
                                    />
                                </v-flex>
                            </v-tab-item>
                            <v-tab-item>
                                <v-data-table
                                    :headers = "headers"
                                    :items = "filtro"
                                    v-model = "selected"
                                    item-key="numarete"
                                    no-results-text = "No hay animales para mostrar"
                                    select-all
                                    hide-actions
                                    class="elevation-1"
                                    :total-items = "totalItems"
                                >
                                    <template slot="items" slot-scope="props">
                                        <td>
                                            <v-checkbox
                                                v-model = "props.selected"
                                                primary
                                                hide-details
                                            ></v-checkbox>
                                        </td>
                                        <td>{{ props.item.numarete }}</td>
                                        <td>{{ props.item.fechanac }}</td>
                                        <td>
                                            <v-avatar>
                                                <img :src = props.item.foto alt="N/A">
                                            </v-avatar>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-tab-item>
                        </v-tabs>
                    </v-layout>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn
                color="blue darken-1"
                text
                @click="cerrar">Cancelar</v-btn>
                <v-btn
                color="blue darken-1"
                text
                @click="guardar">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ServiceHandler from '../../ServiceHandler';

export default {
    props: {
        datos: Object,
        abrir: Boolean,
        nuevo: Boolean,
        ganado: Array,
        cbRanchos: Array,
        cbMedicos: Array,
        titulo: String,
    },
    data() {
        return {
            date: null,
            semen: true,
            selected: [],
            filtro: [],
            totalItems: -1,
            datAdicional: true,
            cbTipoServicio: [
                {'text': 'Inseminación'},
                {'text': 'Pruebas de BR y TB'},
                {'text': 'Vacunación'},
                {'text': 'Desparasitación'},
                {'text': 'Diagnostico 1'},
                {'text': 'Diagnostico 2'},
                {'text': 'Diagnostico 3'},
                {'text': 'Diagnostico Final'},
                {'text': 'Dispositivo 1'},
                {'text': 'Diagnostico 2'},
                {'text': 'Toro'},
            ],
            cbSemen: [
                {'text': 'Resource'},
                {'text': 'Rain Marker'},
                {'text': 'Chimichurri'},
                {'text': 'Duff 1AN 1270-011 WTA'},
                {'text': 'Zorzalito'},
                {'text': 'Federal 18F'}
            ],
            menuFechaIni: false,
            headers: [
                {
                    text: 'Numero de arete',
                    value: 'numarete'
                },
                {
                    text: 'Fecha de nacimiento',
                    value: 'fechanac'
                },
                {
                    text: 'Foto',
                    value: 'foto'
                }
            ]
        }
    },
    
    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      }
    },
        
    methods: {
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
        },
        actualizarFormulario () {
            if(this.datos['tiposervicio'] === 'Pruebas de BR y TB' ||
                this.datos['tiposervicio'] === 'Vacunación' ||
                this.datos['tiposervicio'] === 'Desparasitación'){
                    this.datAdicional = false;
                    this.semen = false
                    this.datos['idtoro'] = '';
                    this.datos['semen'] = '';
            }else{
                this.datAdicional = true;
            }
            if(this.datos['tiposervicio'] === 'Toro') {
                this.semen = false;
                this.datos['semen'] = '';
            }else{
                this.semen = true;
                this.datos['idtoro'] = '';
            }
        },
        actualizarTabla() {
            try{
                this.filtro = [];                
                for (var i=0; i<this.ganado.length; i++){
                    if(this.ganado[i].ranchoproc === this.datos['rancho']){
                        this.filtro.push(this.ganado[i]);
                    }
                }
            }catch(e){
                alert(e.message);
            }
        },
        async guardar() {
            if (!this.nuevo) {
                try{
                    //console.log("entre");
                    await ServiceHandler.updateElement("servvet", this.datos);
                    alert("Se han guardado los cambios realizados en el servicio " + this.datos._id);
                    this.cerrar();
                    this.$emit('actualizarTabla');
                }catch(e){
                    alert("Hubo un error al guardar la información: " + e.message);
                    //this.error = e.message;
                }
            } else {
                try{
                    this.datos.fechacreacion = new Date();
                    const temp = await ServiceHandler.getID("servicios");
                    this.datos._id = "SRV-" + (parseInt(temp.value.sequence_value)+1);
                    this.datos.estatus = "No iniciado";
                    this.datos.fechacreacion = new Date();
                    //console.log(this.datos);
                    await ServiceHandler.insertElement("servvet", this.datos);

                    var tmpAnimales = [];
                    for (var i = 0; i<this.selected.length; i++){
                        tmpAnimales.push({
                            numarete: this.selected[i].numarete,
                            estatus: 'No revisado',
                            observaciones: ''
                        });
                    }
                    var animalServicio = {
                        _id: this.datos._id,
                        listaAnimales: tmpAnimales
                    }
                    //console.log(animalServicio);
                    await ServiceHandler.insertElement("animal_servicio", animalServicio);

                    alert("Se ha generado el servicio con ID " + this.datos._id);
                    this.cerrar();
                    this.$emit('actualizarTabla');
                }catch(e){
                    this.error = e.message;
                }   
            }
        },
        cerrar() {
            this.datos['tiposervicio'] = null;
            this.datos['encargado'] = null;
            this.datos['fechainicio'] = null;
            this.datos['rancho'] = null;
            this.datos['semen'] = null; 
            this.filtro = [];
            this.$emit('cerrarVentana');
        },
        toggleAll () {
            if (this.selected.length) this.selected = [] 
            else this.selected = this.filtro.slice()
        },
        changeSort (column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        }
    },
}
</script>